import React from "react";

const accentColor = {
  default: "#1F3A33",
  success: "#6A8A76",
  danger: "#C84C31",
  muted: "#8A8D86",
};

const toneText = {
  default: "text-[#1A1C19]",
  success: "text-[#1F3A33]",
  danger: "text-[#C84C31]",
  muted: "text-[#5C605A]",
};

export function StatCard({ label, value, hint, icon: Icon, tone = "default", testid }) {
  return (
    <div
      data-testid={testid}
      className="relative bg-white border border-[#1A1C19]/10 rounded-md p-5 sm:p-6 flex flex-col gap-4 shadow-3d-sm hover:shadow-3d transition-all duration-300 hover:-translate-y-[3px] overflow-hidden group card-3d"
    >
      {/* Top accent stripe */}
      <span
        className="absolute top-0 inset-x-0 h-[3px] transition-all group-hover:h-[4px]"
        style={{ backgroundColor: accentColor[tone] }}
        aria-hidden="true"
      />

      <div className="flex items-start justify-between">
        <div className="text-xs font-medium uppercase tracking-wider text-[#8A8D86] font-readex">
          {label}
        </div>
        {Icon && (
          <div className="w-9 h-9 rounded-md bg-[#F5F4EF] flex items-center justify-center transition-colors group-hover:bg-[#F0EFEB]">
            <Icon className="w-4 h-4" strokeWidth={1.5} style={{ color: accentColor[tone] }} />
          </div>
        )}
      </div>

      <div
        key={String(value)}
        className={`font-readex font-medium text-3xl sm:text-4xl tracking-tight font-mono-num tick-in ${toneText[tone]}`}
      >
        {value}
      </div>

      {hint && (
        <div className="flex items-center gap-1.5 text-xs text-[#8A8D86]">
          <span className="w-1.5 h-1.5 rounded-full soft-pulse" style={{ backgroundColor: accentColor[tone] }} />
          {hint}
        </div>
      )}
    </div>
  );
}
